import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useUser } from '../context/userContext';
import { GoHome } from "react-icons/go";
import { RiBarChartFill } from "react-icons/ri";
import { IoSettingsSharp } from "react-icons/io5";

const Footer: React.FC = () => {
  const { isLoggedIn } = useUser();
  const location = useLocation();
  if (!isLoggedIn || location.pathname === '/') return null;  // Only show footer if the user is logged in

  return (
    <footer className="footer">
      <nav>
        <ul>
          <li><NavLink to="/dashboard"><GoHome /></NavLink></li>
          <li><NavLink to="/data"><RiBarChartFill /></NavLink></li>
          <li><NavLink to="/timetable"><IoSettingsSharp /></NavLink></li>
        </ul>
      </nav>
    </footer>
  );
};

export default Footer;
